"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./StudyPlanTopic.css");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StudyPlanTopic = ({
  topic,
  index,
  topicType = 'current',
  isCompleted,
  isCurrent
}) => {
  const completed = isCompleted !== undefined ? isCompleted : topicType === 'past';
  const current = isCurrent !== undefined ? isCurrent : topicType === 'current';
  const circleClass = current ? 'circle-number-in-progress' : completed ? 'circle-number-done' : '';
  const showCheckmark = completed && !current;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "list-counter-item p-1",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: `circle-number ${circleClass}`,
      children: showCheckmark ? '✓' : index + 1
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: `item-text ${completed ? 'item-text-done' : ''}`,
      children: topic.title
    })]
  });
};
var _default = exports.default = StudyPlanTopic;